import { getTheme } from "@fluentui/react";
import { Checkbox, Divider, makeStyles } from "@fluentui/react-components";
import {
  AirplaneLandingFilled,
  AirplaneTakeOffFilled,
} from "@fluentui/react-icons";
import React from "react";
import { CommonHelper } from "../../../utils/common/CommonHelper";
import GroupIcon from "./../../../assests/flights/group.svg";
import HideUnhideActions from "./HideUnhideActions";

export default function CustomColumnDropdown({
  transformColumns,
  handleColumnCheckboxChange,
  onResetHandler,
  onDefaultHandler,
  onApplyHandler,
}: any) {
  const classes = useStyles();
  return (
    <>
      <div
        className={`${classes.container} `}
        data-testid="hide-unhide-columns"
      >
        <div className={`d-flex ai-center`}>
          <div className="mt-1">
            <img src={GroupIcon} alt="Group image" />
          </div>
          <div className={`fs-20 fw-600 ${classes.heading}`}>
            Customize columns
          </div>
        </div>
        <Divider />
        <div className={`${classes.checkboxContainer}`}>
          {transformColumns.map((column: any) => {
            return (
              <div key={column.id} className={`${classes.checkbox} ai-center`}>
                <Checkbox
                  disabled={column.disabled}
                  label={
                    <>
                      {column.label.includes("Arrival") && (
                        <>
                          <AirplaneLandingFilled
                            style={{ marginRight: "8px" }}
                          />
                          {column.label
                            .split(" ")
                            .filter(
                              (word: string) => word.toLowerCase() !== "arrival"
                            )

                            .map((word: string) => (
                              <React.Fragment key={CommonHelper.getGuid()}>
                                {word}{" "}
                              </React.Fragment>
                            ))}
                        </>
                      )}
                      {column.label.includes("Departure") && (
                        <>
                          <AirplaneTakeOffFilled
                            style={{ marginRight: "8px" }}
                          />
                          {column.label
                            .split(" ")
                            .filter(
                              (word: string) =>
                                word.toLowerCase() !== "departure"
                            )

                            .map((word: string) => (
                              <React.Fragment key={CommonHelper.getGuid()}>
                                {word}{" "}
                              </React.Fragment>
                            ))}
                        </>
                      )}
                      {!column.label.includes("Arrival") &&
                        !column.label.includes("Departure") &&
                        column.label
                          .split(" ")
                          .map((word: string) => (
                            <React.Fragment key={CommonHelper.getGuid()}>
                              {word.toLowerCase() !== "common" ? word : null}{" "}
                            </React.Fragment>
                          ))}
                    </>
                  }
                  checked={column.checked}
                  onChange={() => {
                    handleColumnCheckboxChange(column.id);
                  }}
                />
              </div>
            );
          })}
        </div>
      </div>
      <Divider />
      <HideUnhideActions
        onResetHandler={onResetHandler}
        onDefaultHandler={onDefaultHandler}
        onApplyHandler={onApplyHandler}
      />
    </>
  );
}
const theme = getTheme();

const useStyles = makeStyles({
  heading: {
    padding: "15px",
  },
  checkboxContainer: {
    padding: "20px",
  },

  checkbox: {
    lineHeight: "2",
  },
  container: {
    padding: "0px 10px 10px 10px",
    maxHeight: "400px",
    overflowY: "auto",
  },
});
